<template>
  <div
    v-if="counters"
    class="tags-container v-alerts-counter"
  >
    <el-tag
      v-if="counters.error"
      type="danger"
    >
      {{ errorAlertCount }}
    </el-tag>
    <el-tag
      v-if="counters.warning"
      type="warning"
    >
      {{ warningAlertCount }}
    </el-tag>
    <el-tag
      v-if="counters.info"
      type="info"
    >
      {{ infoAlertCount }}
    </el-tag>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export const MAX_ALERT_COUNT = 99;

  export default defineComponent({
    name: 'AlertsCounter',
    props: {
      counters: Object
    },
    computed: {
      errorAlertCount() {
        return this.getAlertCount(this.counters?.error);
      },
      warningAlertCount() {
        return this.getAlertCount(this.counters?.warning);
      },
      infoAlertCount() {
        return this.getAlertCount(this.counters?.info);
      }
    },
    methods: {
      getAlertCount(num: number) {
        return num > MAX_ALERT_COUNT ? `${MAX_ALERT_COUNT} +` : num;
      }
    }
  });
</script>

<style lang="scss" scoped>
  .el-tag {
    margin-left: 4px;

    &:first-child {
      margin-left: 8px;
    }
  }
</style>
